import React from 'react'

const DEFAULT_NAME = 'Trip Name'

export class TripTitle extends React.Component {
    constructor(props) {
        super(props)

        // TODO: this relies on jQuery but is the cleanest way to handle without a different extra lib.
        let cleanTrip = props.tripName ? $('<div />').html(props.tripName).text() : null

        this.state = {
            editStatus: false,
            editTitle: cleanTrip || DEFAULT_NAME
        }


        this.handleClick = this.handleClick.bind(this)
        this.handleUpdateTitle = this.handleUpdateTitle.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
    }

    handleClick() {
        this.setState({
            editStatus: true
        })
    }

    handleUpdateTitle(evt) {
        this.setState({editTitle: evt.target.value})
    }

    deactivateEdit() {
        this.props.onUpdateTripTitle(this.state.editTitle)

        this.setState({
            editStatus: false
        })
    }

    handleBlur() {
        this.deactivateEdit()
    }

    handleKeyPress(evt) {
        if (evt.key === 'Enter') {
            this.deactivateEdit()
        }
    }

    render() {
        let display = null

        if (this.state.editStatus) {
            display = <input
        type="text"
        autoFocus
        value={this.state.editTitle}
        onChange={ this.handleUpdateTitle }
        onKeyPress={ this.handleKeyPress }
        onBlur={ this.handleBlur }/>
        } else {
            let tripTitle = this.props.tripName ? this.props.tripName : DEFAULT_NAME
            display = <h1 onClick={ this.handleClick } dangerouslySetInnerHTML={{__html: tripTitle}}/>
        }

        return (
            <div className="trip-title">
                { display }
            </div>
        )
    }
}
